var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "x",
  "use": "x-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"x\"><path fill=\"#fff\" d=\"M2.667 0A2.667 2.667 0 0 0 0 2.667v10.666A2.667 2.667 0 0 0 2.667 16h10.666A2.667 2.667 0 0 0 16 13.333V2.667A2.667 2.667 0 0 0 13.333 0zm.794 3.429h3.024l2.147 3.05 2.606-3.05h.953L9.062 7.09l3.858 5.48H9.897l-2.492-3.54-3.024 3.54h-.952l3.546-4.15zm1.459.761 5.374 7.62h1.167L6.087 4.19z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol